import { Company } from './../../models/CompanyDTO';
import { IApiQueryListResponse } from './../../interfaces/api/api-query-list-response/api-query-list-response.interface';
import { DefaultResponse } from './../../models/form/DefaultResponse';
import { CadastroSteps } from './../../enum/cadastro.enum';
import { InternetService } from './../internet/internet.service';
import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';
import { SettingsService } from '../settings/settings.service';
import { RoutesTable } from '../../resources/routes-table.model';
import { CompanyRegistrationStep } from './../../enum/company-registration-step.enum';
import { UserManagerService } from '../../services/users/user-manager.service';
import { StorageService } from '../../services/storage.service';
import { BackendService as NewBackendService} from '../../services/new-http/backend.service';
import { of } from 'rxjs';

@Injectable()
export class UserProfileService {
    constructor(
        private dataService: BackendService,
        private externalData: InternetService,
        private settings: SettingsService,
        private backendService: NewBackendService) {
    }

    public updateUser(UserPayload) {
        switch (UserPayload.step) {
            case CadastroSteps.basic: {
                const captcha = UserPayload.value.captcha ? UserPayload.value.captcha : null;
                const captchaSiteKey = UserPayload.value.captchaSiteKey ? UserPayload.value.captchaSiteKey : null;
                // Create a copy to avoid mutating immutable NgRx state
                const payload = { ...UserPayload.value };
                delete payload.captcha;
                delete payload.captchaSiteKey;
                return this.dataService
                .post<DefaultResponse>('v1.1/users/basic-registration', payload, null, captcha, captchaSiteKey, "cadastro", "enterprise");
            }

            case CadastroSteps.personalinformations:
                return this.dataService
                .put<DefaultResponse>('userprofile', UserPayload.value);

            case CadastroSteps.address:
                return this.dataService
                .put<DefaultResponse>('userprofile', UserPayload.value);

            case CadastroSteps.bank:
                return this.dataService
                .put<DefaultResponse>('userprofile/bankAccount', UserPayload.value);

            case CadastroSteps.insertBank:
                return this.dataService
                .post<DefaultResponse>('userprofile/bankAccount', UserPayload.value);

            case CadastroSteps.patrimony:
                return this.dataService
                .patch<DefaultResponse>('v1.1/users', UserPayload.value);

            case CadastroSteps.documentation:
                return this.dataService
                .put<DefaultResponse>('userprofile', UserPayload.value);

            default:
                return this.dataService
                .put<DefaultResponse>('userprofile', UserPayload.value);
        }
    }

    updatePatchUser(UserPayload) {
        switch (UserPayload.step) {
            case CadastroSteps.basic:
                return this.dataService.post<DefaultResponse>('userprofile/basicregistration', UserPayload.value);

            case CadastroSteps.personalinformations:
                return this.dataService.patch<DefaultResponse>('v1.1/users', UserPayload.value);

            case CadastroSteps.address:
                return this.dataService.patch<DefaultResponse>('v1.1/users', UserPayload.value, UserPayload.token);

            case CadastroSteps.bank:
                return this.dataService.put<DefaultResponse>('userprofile/bankaccount', UserPayload.value);

            case CadastroSteps.insertBank:
                return this.dataService.post<DefaultResponse>('userprofile/bankaccount', UserPayload.value);

            case CadastroSteps.patrimony:
                return this.dataService.patch<DefaultResponse>('v1.1/users', UserPayload.value, UserPayload.token);

            case CadastroSteps.documentation:
                return this.dataService.patch<DefaultResponse>('v1.1/users', UserPayload.value, UserPayload.token);

            default:
                return this.dataService.patch<DefaultResponse>('userprofile/individualcustomer', UserPayload.value, UserPayload.token);
        }
    }

    updateUserTags(userTagPayload: { key: string, value: string }) {
        return this.dataService.put<DefaultResponse>('v2/tags', userTagPayload);
    }

    updatePatchCompany(UserPayload) {
        switch (UserPayload.step) {
            case CompanyRegistrationStep.Address:
                return this.dataService.patch<DefaultResponse>('userprofile/corporatecustomer', UserPayload.value, UserPayload.token);

            case CompanyRegistrationStep.Partners:
                return this.dataService.post<DefaultResponse>('userprofile/corporatecustomer/partner', UserPayload.value, UserPayload.token);

            case CompanyRegistrationStep.BankData:
                return this.dataService.post<DefaultResponse>('userprofile/bankaccount', UserPayload.value, UserPayload.token);

            case CompanyRegistrationStep.Patrimony:
                return this.dataService.patch<DefaultResponse>('userprofile/corporatecustomer', UserPayload.value, UserPayload.token);

            case CompanyRegistrationStep.RelatedEnterprises:
                return this.dataService.post<DefaultResponse>('userprofile/corporatecustomer/relatedcompany', UserPayload.value, UserPayload.token);

            case CompanyRegistrationStep.Emitters:
                return this.dataService.post<DefaultResponse>('userprofile/corporatecustomer/emitter', UserPayload.value, UserPayload.token);

            default:
                return this.dataService.patch<DefaultResponse>('userprofile/corporatecustomer', UserPayload.value, UserPayload.token);
        }
    }

    getUser() {
      const configCustomOptions = this.settings.getConfigurationKeyValue('customOptions');
      const defaultUserProfileRequest = this.dataService.get<DefaultResponse>('userprofile');

      if (!configCustomOptions || !configCustomOptions.cacheUserProfile)
        return defaultUserProfileRequest;

      const userJWT = StorageService.getCookie(UserManagerService.userPayloadStorageKey);
      const userProfileData: {data: Record<string, unknown>, token: string} = JSON.parse(sessionStorage.getItem('userProfileData'));

      if (userProfileData) {
        if (userJWT === userProfileData.token) {
           return of(this.createDefaultResponseWithCachedUserData(userProfileData.data));
        }

        sessionStorage.removeItem('userProfileData');
      }

      return defaultUserProfileRequest;
    }

    getUserByCBLC() {
        return this.dataService.get<DefaultResponse>('userprofile/cblc');
      }

    getUserToroUser() {
        const defaultUserProfileRequest = this.dataService.get<DefaultResponse>('v1.1/users/userprofile');

        const configCustomOptions = this.settings.getConfigurationKeyValue('customOptions');
        if (!configCustomOptions || !configCustomOptions.cacheUserProfile) {
          return defaultUserProfileRequest;
        }

        const userJWT = StorageService.getCookie(UserManagerService.userPayloadStorageKey);
        const userProfileData: {data: Record<string, unknown>, token: string} = JSON.parse(sessionStorage.getItem('userProfileData'));

        if (userProfileData) {
          if (userJWT === userProfileData.token) {
             return of(this.createDefaultResponseWithCachedUserData(userProfileData.data));
          }
          sessionStorage.removeItem('userProfileData');
        }
        return defaultUserProfileRequest;
      }

    public cacheUserProfileDataIfNeeded(userData) {
        const configCustomOptions = this.settings.getConfigurationKeyValue("customOptions");
        const configOptionsGavePermissionToCache = configCustomOptions && configCustomOptions.cacheUserProfile;
        const userDataIsValidToCache = userData.cblc;

        if (configOptionsGavePermissionToCache && userDataIsValidToCache) {
          const userJWT = StorageService.getCookie(
            UserManagerService.userPayloadStorageKey
          );
          sessionStorage.setItem(
            "userProfileData",
            JSON.stringify({ token: userJWT, data: userData })
          );
        }
    }

    public getUserCblcDigit(cblc: number) {
        const iBroker = 4090;
        const iAccount = cblc;
        const arrBrokerAccount = [
            Math.trunc(iAccount % 10),
            Math.trunc(iAccount % 100 / 10),
            Math.trunc(iAccount % 1000 / 100),
            Math.trunc(iAccount % 10000 / 1000),
            Math.trunc(iAccount % 100000 / 10000),
            Math.trunc(iBroker % 10),
            Math.trunc(iBroker % 100 / 10),
            Math.trunc(iBroker % 1000 / 100),
            Math.trunc(iBroker % 10000 / 1000),
            Math.trunc(iBroker % 100000 / 10000),
            Math.trunc(iAccount % 1000000 / 100000),
            Math.trunc(iAccount % 10000000 / 1000000),
            Math.trunc(iAccount % 100000000 / 10000000),
        ];

        const arrFatores = [2 , 3, 4 , 5, 6, 7, 8, 9];
        let iSoma = 0;
        for(let index = 0; index < arrBrokerAccount.length; index++){
            iSoma += arrBrokerAccount[index] * arrFatores[index % arrFatores.length]
        }

        return ((iSoma*10)%11)%10;
    }

    private createDefaultResponseWithCachedUserData(userCachedData): DefaultResponse {
      return {
        value: userCachedData,
        hasValue: true,
        messages: [],
        hasWarning: false,
        hasAlerta: false,
        hasError: false,
        hasInfo: false,
        ok: true,
       };
    }

    getCompany() {
        return this.dataService.get<IApiQueryListResponse<Company>>( RoutesTable.usercompany.routes.get.uri );
    }
}
